import i18n from 'i18next'

import keyMetricsApi from 'api/ApiActions/Reporting/Overview/KeyMetrics'
import activityOverTimeApi from 'api/ApiActions/Reporting/Overview/ActivityOverTime'
import visitorEngagementApi from 'api/ApiActions/Reporting/Overview/VisitorEngagement'
import topPerformingToolsApi from 'api/ApiActions/Reporting/Overview/TopPerformingTools'
import contributionTagsApi from 'api/ApiActions/Reporting/Overview/ContributionTags'
import contributionsLocationApi from 'api/ApiActions/Reporting/Overview/ContributionsLocation'

const saveCSV = (response: any, fileNameKey: string) => {
  //\ufeff is added in the response data to translate the text in the csv file, if removed translations wont work
  const translatedResponseData = `\ufeff${response.data}`
  const url = window.URL.createObjectURL(new Blob([translatedResponseData]))
  const fileName = `${i18n.t(`reporting.fileName.${fileNameKey}`)}.csv`
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}

export const downloadCSV = async (filters: any, fileNameKey: string) => {
  let response = {}

  const downloadAsCSVOptions: Record<string, () => object> = {
    keyMetrics: () => keyMetricsApi.downloadCSV(filters),
    activityOverTime: () => activityOverTimeApi.downloadCSV(filters),
    visitorsEngagement: () => visitorEngagementApi.downloadCSV(filters),
    topPerformingTools: () => topPerformingToolsApi.downloadCSV(filters),
    contributionTags: () => contributionTagsApi.downloadCSV(filters),
    contributionsLocation: () => contributionsLocationApi.downloadCSV(filters),
  }

  response = await downloadAsCSVOptions[fileNameKey]()

  saveCSV(response, fileNameKey)
}
